import React from 'react';
import { Link } from 'react-router-dom';

const Section3 = ({ 
  style, 
  logoImagePath, 
  desktopImagePath, 
  loanTextContent, 
  loanTextIndex, 
  isMobile 
}) => {
  return (
    <section className="section-3" style={style}>
      <div className="container">
        <div className="section-3-content">
          <div className="loan-disbursement-container">
            <Link to="/">
              <img 
                src={logoImagePath} 
                alt="L&T Finance Logo" 
                className="logo-image" 
                style={{ alignSelf: 'flex-start', marginLeft: '-150px' }} 
                loading="lazy"
              />
            </Link>
            
            <div className="loan-text-carousel">
              <h2 
                className="loan-title" 
                key={`title-${loanTextIndex}`}
                style={{ fontWeight: 400 }}
              >
                {loanTextContent[loanTextIndex].topLine}
              </h2>
              <h3 
                className="in-minutes" 
                key={`minutes-${loanTextIndex}`}
                style={{ fontWeight: 700 }}
              >
                {loanTextContent[loanTextIndex].bottomLine}
              </h3>
            </div>
            
            <a 
              href="https://ltfbusinessloans.ltfinance.com/?utm_source=PosterWebsite&utm_medium=Apply+now&utm_campaign=Poster+Website" 
              className="btn-neo start-btn" 
              target="_blank"
              rel="noopener noreferrer"
            >
              Apply Today <span>&gt;</span>
            </a>
            <div
              className="section3-tnc"
              style={{
                color: 'white',
                marginTop: '8px',
                opacity: 0.85,
                lineHeight: 1.3,
                fontSize: isMobile ? '8px' : '9.5px'
              }}
            >
              <Link 
                to="/terms-and-conditions"
                style={{ 
                  color: 'white', 
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#FFCB03'}
                onMouseLeave={(e) => e.target.style.color = 'white'}
              >
                *T&C apply
              </Link>
              .{' '}
              <a
                href="https://www.ltfinance.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'white', textDecoration: 'none' }}
              >
                Visit www.LTFINANCE.com&nbsp;to&nbsp;know&nbsp;more
              </a>
            </div>
          </div>
        </div>
        
        {/* Desktop image is shown in mobile/tablet view at the very bottom - Optimized loading */}
        {isMobile && (
          <div className="section-3-desktop-image">
            <img 
              src={desktopImagePath} 
              alt="Desktop" 
              loading="lazy"
              decoding="async"
              onLoad={(e) => e.target.style.opacity = '1'}
              style={{ opacity: '0', transition: 'opacity 0.5s ease' }}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default Section3; 